var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIwwaUploadarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 446,
    viewBox: "0 0 447 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.556 250.386C293.113 250.386 291.726 249.826 290.687 248.825L215.123 175.959L139.905 248.524C138.839 249.55 137.409 250.11 135.93 250.082C134.45 250.054 133.043 249.439 132.017 248.373C130.99 247.307 130.43 245.877 130.458 244.398C130.486 242.918 131.101 241.511 132.167 240.484L211.254 164.207C212.292 163.204 213.678 162.643 215.121 162.641C216.564 162.639 217.952 163.196 218.992 164.196L298.414 240.786C299.217 241.555 299.772 242.548 300.006 243.636C300.241 244.724 300.144 245.857 299.729 246.889C299.314 247.922 298.6 248.807 297.678 249.43C296.756 250.053 295.669 250.386 294.556 250.386Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.12 398.82C213.641 398.82 212.223 398.233 211.178 397.187C210.132 396.142 209.545 394.724 209.545 393.245V168.216C209.545 166.737 210.132 165.319 211.178 164.274C212.223 163.228 213.641 162.641 215.12 162.641C216.599 162.641 218.017 163.228 219.062 164.274C220.108 165.319 220.695 166.737 220.695 168.216V393.256C220.692 394.733 220.103 396.148 219.058 397.191C218.013 398.234 216.597 398.82 215.12 398.82Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIwwaUploadarrow);
export default __webpack_public_path__ + "static/media/iwwa_upload arrow.0dc07ed4b4a03953c22d702cfc7c71da.svg";
export { ForwardRef as ReactComponent };